module.exports = __webpack_public_path__ + "static/media/icon-calender-right-white.ee38635e.svg";